import BaseObject from '../../base/base_object';
import ServiceFactory from '../service_factory';
import { SYSTEM_EVENTS } from "../../events/events";
import Event from '../../utils/event';
import {TimeSpan} from "@sparkware/app-utils";
import DOM from '../../utils/dom';
import _ from "../../utils/underscore";
import { ILiveTablesServiceParams } from './live_tables_service';
import { ILiveTableInfo } from './live_table_info';

export default class LiveTablesStore extends BaseObject {
	static CLASS = 'LiveTablesStore';
	private _serviceFactory: ServiceFactory;
	private _params: ILiveTablesServiceParams;

	private _isStarted = false;
	private _currentFeedsRegulationID: number;
	private _currentFeeds: { [id: number]: ILiveTableInfo };

	private _feedsInterval: number;

	init(params: ILiveTablesServiceParams & { serviceFactory: ServiceFactory }) {
		super.init(params);
		this._serviceFactory = params.serviceFactory;
		this._params = params;
	}

	public start(): void {
		const feedsIntervalFrequency = TimeSpan.parse(this._params.refreshInterval).totalMilliseconds;

		if (this._isStarted === false) {
			this._isStarted = true;
			this._readFromServer();
			this._feedsInterval = DOM.setInterval(() => {
				this._readFromServer();
			}, feedsIntervalFrequency);
		}
	}

	/**
	 * stop update the feeds from server.
	 */
	public stop(): void {
		if (this._feedsInterval) {
			DOM.clearInterval(this._feedsInterval);
		}
		this._isStarted = false;
	}

	/**
	 * if the regulation id for evo feeds changed - call to server. if not, return the current feeds.
	 */
	public getTablesInfo(): Promise<{ [id: number]: ILiveTableInfo }> {
		if (this._serviceFactory.liveTablesService().getRegulationIDForMinMaxBet() === this._currentFeedsRegulationID && this._currentFeeds) {
			return Promise.resolve(this._currentFeeds);
		} else {
			return this._readFromServer();
		}
	}

	private _readFromServer(): Promise<{ [id: number]: ILiveTableInfo }> {
		const regulationID = this._serviceFactory.liveTablesService().getRegulationIDForMinMaxBet();
		return this._serviceFactory.http2Service().post< { LiveTables: { [id: number]: ILiveTableInfo } } >(this._params.liveTablesUrl, { regulationID: regulationID && regulationID.toString() })
			.then(data => {
				if (_.isNullOrUndefined(data)) {
					return {};
				}

				this._currentFeeds = data.LiveTables;
				this._currentFeedsRegulationID = regulationID;
				this._evaluateBetLimitsForCurrentFeeds();

				Event.fire(SYSTEM_EVENTS.LIVE_TABLES_UPDATE, this._currentFeeds);
				return this._currentFeeds;
			}).catch(err => {
				this.logger.warn("Evolution new feeds: fail to get data. error: " + err);
				return null;
			});
	}

	private _evaluateBetLimitsForCurrentFeeds(): void {
		const currency = this._serviceFactory.currencyService().getCurrency().toUpperCase();
		const properties = Object.getOwnPropertyNames(this._currentFeeds);
		properties.forEach(property => {
			const limits = this._currentFeeds[property].Limits;
			const relevantLimit = limits.find(elem => {
				return elem.currency === currency;
			});

			this._currentFeeds[property].MinBet = relevantLimit && relevantLimit.minBet;
			this._currentFeeds[property].MaxBet = relevantLimit && relevantLimit.maxBet;
		});
	}
}
